import React from "react";
import { connect } from "react-redux";
import { postCall } from "../../Core/User/Call/action";
import Loader from '../Loader';
import styles from "../../Assets/Styles/Components/login/CountdownTimer.module.css";

class CountdownTimer extends React.Component {
	constructor(props) {
		super(props);
		this.state = { seconds: props.seconds };
	}

	componentDidMount() {
		this.timer = setInterval(this.tick, 1000);
	}

	tick = () => {
		const { seconds } = this.state;
		if (seconds > 0) {
			this.setState({ seconds: seconds - 1 });
		}
	}

	onCall = () => {
		this.props.postCall(this.props.phone);
	}

	// TODO: change render part with less code
	render() {
		const { seconds } = this.state;
		if (seconds > 0) {
			return (<div>00:{seconds}</div>);
		}

		const { callConfirm, call } = this.props;
		return (
			<div className={styles.marginText}>
				{call.loading ? <Loader /> : <div onClick={this.onCall} style={{ cursor: "pointer" }}>دریافت کد توسط تماس</div>}
				{call.call?.message && call.call.message.length !== 0 && <p className={styles.resMessage}>{call.call.message[0]}</p>}
				{call.call?.error && call.call.error.length !== 0 && <p className={styles.errMessage}>{call.call.error[0]}</p>}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		call: state.call,
	};
};

export default connect(mapStateToProps, { postCall })(CountdownTimer);
